import { keepPreviousData } from '@tanstack/react-query';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { PaginationState } from '@tanstack/react-table';
import { useGetInvitations } from '../../hooks/useInvitations';
import { EmployeesSearchParams } from '../../types';
import { ListInvitationsTable } from '../ListInvitationsTable/ListInvitationsTable';

export function ListInvitationsTab() {
  const search = useSearch({
    strict: false,
  }) as EmployeesSearchParams;
  const navigate = useNavigate();

  const {
    isLoading: isLoadingInvitations,
    data: {
      data: invitations = [],
      metadata: { total = 0, page = 1 } = {},
    } = {},
  } = useGetInvitations(
    undefined,
    {
      page: search.page || 1,
      limit: search.limit || 10,
    },
    {
      placeholderData: keepPreviousData,
    },
  );

  const paginationState = {
    pageIndex: (page ?? 1) - 1 || 0,
    pageSize: search.limit || 10,
  };

  const onPaginationChange = ({ pageIndex, pageSize }: PaginationState) => {
    navigate({
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        page: pageIndex + 1,
        limit: pageSize,
      }),
    });
  };

  return (
    <>
      <header className="px-8 pb-6 border-b">
        <h2 className="font-semibold text-xl">Pending Invitations</h2>
      </header>
      <div className="flex-1 mt-6 px-8">
        <ListInvitationsTable
          isLoading={isLoadingInvitations}
          invitations={invitations}
          tableOptions={{
            enablePagination: !!total,
            rowCount: total,
            onPaginationChange: updater => {
              return typeof updater === 'function'
                ? onPaginationChange(updater(paginationState))
                : onPaginationChange(updater);
            },
            state: {
              pagination: paginationState,
            },
          }}
        />
      </div>
    </>
  );
}
